import { authClient } from '@/shared/utils/axios/api'
import { queryOptions } from '@tanstack/react-query'
import type { OidcClientConfig } from '../types/authTypes'

const getConfig = async (): Promise<OidcClientConfig> => {
  const { data } = await authClient.get(`/.well-known/openid-configuration`)
  return data
}

const getConfigOptions = () => {
  return queryOptions({
    queryKey: ['oidc-config'],
    queryFn: () => getConfig(),
  })
}

export { getConfig, getConfigOptions }
